module.exports = __webpack_public_path__ + "img/team-dark-01.d649a0a8.jpg";